import { render, staticRenderFns } from "./SkinDysfunctionResults.vue?vue&type=template&id=800da4e2&scoped=true"
import script from "./SkinDysfunctionResults.vue?vue&type=script&lang=js"
export * from "./SkinDysfunctionResults.vue?vue&type=script&lang=js"
import style0 from "./SkinDysfunctionResults.vue?vue&type=style&index=0&id=800da4e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800da4e2",
  null
  
)

export default component.exports